import { FC } from "react";
import { Link } from "react-router-dom";
import AuthSubHeader from "src/components/authSubHeader";
import FooterText from "src/components/footerText";



const YearEndEmail: FC = (): JSX.Element => {
  return (
    <div className="container-fluid overflow-y-auto overflow-x-auto d-flex flex-column flex-fill">
      <div style={{ marginRight: "5rem", marginLeft: "5rem" }}>
        <AuthSubHeader />
        <p>Dear QUTENZA Prescriber:</p>
        <p>
          Averitas Pharma, Inc., and your team at My QUTENZA Connect (MQC) want to thank you for everything you do to help treat 
          your patients with QUTENZA. As we approach the holidays, we want to provide an update about our plan to reverify 
          patient benefits.
        </p>
        <p>
          REVERIFICATION OF BENEFITS: MQC routinely reverifies patient benefits 21 days before a next treatment is anticipated. 
          This timetable allows you to schedule treatment 91 days from the prior treatment, as clinically appropriate. As a 
          reminder, QUTENZA is approved by the Food and Drug Administration (FDA) for use every three months — but not more 
          frequently than every three months. Payers align their coverage policies with the FDA guidelines.
        </p>
        <p>
          My QUTENZA Connect will continue to work seamlessly through the holidays supporting all requests received, with the exception 
          of December 25, 2025 and January 1, 2026. However, if you have previously requested automatic reverifications for patients, 
          we will not process any reverifications triggered by the system from December 20 to December 31, 2025. These reverifications 
          will be provided to you during the first week of January 2026 in order to accurately reflect patients' 2026 benefit plans, as 
          these may change in the new calendar year. This temporary modification will affect only reverifications triggered by the system. 
          All other support and the quality of service you expect from My QUTENZA Connect will remain unchanged.
        </p>
        <p>
          If any of your patients should receive their next QUTENZA treatment in January and they aren't already on the treatment calendar, 
          My QUTENZA Connect is ready to support you in every way possible, including benefits investigation or prior authorization needs. 
          My QUTENZA Connect is open Monday through Friday from 9am to 7pm ET, again with the exception of December 25, 2025, and January 
          1, 2026. In addition, our physician portal is available for use 24 hours a day, seven days a week. It can be accessed at{' '}
          <Link to="/users/sign_in">
            https://myqutenzaconnect.com/users/sign_in
          </Link>.
        </p>
        <p>My QUTENZA Connect</p>
        <p>1-855-802-8746</p>
        <p>Monday through Friday, from 9 a.m. to 7 p.m. ET</p>
        <p>
          Thank you for supporting your patients' access to treatment with QUTENZA. We send you best wishes for the holidays and for 
          the new year.
        </p>
        <p>INDICATION</p>
        <p>
          QUTENZA (capsaicin) 8% topical system is indicated in adults for the treatment of neuropathic pain associated with postherpetic 
          neuralgia (PHN) and for neuropathic pain associated with diabetic peripheral neuropathy (DPN) of the feet.
        </p>
        <p>IMPORTANT SAFETY INFORMATION</p>
        <p>
          Do not dispense QUTENZA to patients for self-administration or handling. Use only on dry, unbroken skin. Only physicians or 
          healthcare professionals are to administer and handle QUTENZA, following the procedures on the label.
        </p>
        <p>Warnings and Precautions</p>
        <ul>
          <li>
            Severe Irritation: Whether applied directly or transferred accidentally from other surfaces, capsaicin can cause severe 
            irritation of eyes, mucous membranes, respiratory tract, and skin to the healthcare professional, patients, and others. Do 
            not use near eyes or mucous membranes, including face and scalp. Take protective measures, including wearing nitrile gloves 
            and not touching items or surfaces that the patient may also touch. Flush irritated mucous membranes or eyes with water and 
            provide supportive medical care for shortness of breath. Remove affected individuals from the vicinity of QUTENZA. Do not 
            re‑expose affected individuals to QUTENZA if respiratory irritation worsens or does not resolve. If skin not intended to be 
            treated comes into contact with QUTENZA, apply Cleansing Gel and then wipe off with dry gauze. Thoroughly clean all areas 
            and items exposed to QUTENZA and dispose of properly. Because aerosolization of capsaicin can occur with rapid removal, 
            administer QUTENZA in a well‑ventilated area, and remove gently and slowly, rolling the adhesive side inward.
          </li>
          <li>
            Application-Associated Pain: Patients may experience substantial procedural pain and burning upon application and following 
            removal of QUTENZA. Prepare to treat acute pain during and following application with local cooling and/or appropriate 
            analgesic medication.
          </li>
          <li>
            Increase in Blood Pressure: Transient increases in blood pressure may occur with QUTENZA treatment. Monitor blood pressure 
            during and following treatment procedure and provide support for treatment‑related pain. Patients with unstable or poorly 
            controlled hypertension, or a recent history of cardiovascular or cerebrovascular events, may be at an increased risk of 
            adverse cardiovascular effects. Consider these factors prior to initiating QUTENZA treatment.
          </li>
          <li>
            Sensory Function: Reductions in sensory function (generally minor and temporary) have been reported following administration 
            of QUTENZA. Assess for signs of sensory deterioration or loss prior to each application of QUTENZA. If sensory loss occurs, 
            treatment should be reconsidered.
          </li>
          <li>
            Severe Application Site Burns: Full-thickness (third-degree) and deep partial-thickness (second-degree) burns have been reported 
            following administration of QUTENZA. Cases of full-thickness (third-degree) burns, requiring hospitalization and skin grafting 
            have been reported in patients who received QUTENZA for an unapproved indication and/or frequency of dosing at an application 
            site where there had been prior skin trauma. Ensure that dosage and administration recommendations are followed.
          </li>
        </ul>
        <p>Adverse Reactions</p>
        <p>
          The most common adverse reactions (≥5% and {`>`} control group) in all controlled clinical trials are application site erythema, 
          application site pain, and application site pruritus.
        </p>
        <p>
          To report SUSPECTED ADVERSE REACTIONS, contact Averitas Pharma, Inc. at 1-877-900-6479 or FDA at 1-800-FDA-1088 or{' '}
          <a href="https://www.fda.gov/medwatch">www.fda.gov/medwatch</a>.
        </p>
        <p>Please see <a href="https://www.qutenza.com/pdfs/%20Qutenza_Prescribing_Information.pdf" target="_blank" rel="noreferrer">full Prescribing Information</a>.</p>
        <p>QZA-11-23-0013 v3.0 October 2025</p>
        <FooterText />
      </div>
    </div>
  )
}

export default YearEndEmail;
